import { SandboxedHTMLPreview } from "@tellescope/ui";
import { sanitizeEmailHTMLContent } from "@tellescope/utils";
import { useTranslation } from "react-i18next";

import { decorateTokensAsBadges } from "./htmlTokenSegments";

export interface TemplateHtmlPreviewProps {
  html: string;
  className?: string;
  title?: string;
}

export const TemplateHtmlPreview = ({ html, className, title }: TemplateHtmlPreviewProps) => {
  const { t } = useTranslation("templates");

  return (
    <SandboxedHTMLPreview
      html={`<div style="font-family:sans-serif">${sanitizeEmailHTMLContent(decorateTokensAsBadges(html))}</div>`}
      title={title ?? t("Preview")}
      className={className}
    />
  );
};
